import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { fetchUserLineups, selectLineups, selectLineupsStatus } from '../SettingsState/lineupsSlice'
import { DataError, SettingsHeader, SettingsOptionsContainer, CenterText, StyledLink, SettingsTextInput } from './SettingsStyles';
import { DataState, TransferPage } from '../../../interfaces/enums';
import GridFailed from '../../GridPages/components/GridFailed';
import GridLoading from '../../GridPages/components/GridLoading';
import {
	postLegacyTitanTVMigrate, selectUserId, selectLineupTransferList, selectOldAccountLoadingStatus, selectOldTitanAccount,
	setTransferPage, selectAccountMigrationStatus, setAccountMigrationStatus, selectIsAnonymous
} from '../SettingsState/userSlice';
import LineupSelectionBox from './LineupSelectionBox';
import { BlueButton } from '../../Global/GobalStyledComponents';
import { useEffect, useState } from 'react';
import { fetchUserSettings } from '../SettingsState/gridSettingsSlice';
import { fetchFavorites } from '../SettingsState/favoritesRemidersSlice';
import { useNavigate } from 'react-router-dom';

const TransferLineups = () => {
	const oldAccount = useAppSelector(selectOldTitanAccount);
	const oldAccountLoadingStatus = useAppSelector(selectOldAccountLoadingStatus);
	const accountMigrationStatus = useAppSelector(selectAccountMigrationStatus);
	const lineups = useAppSelector(selectLineups);
	const lineupStatus = useAppSelector(selectLineupsStatus)
	const transferList = useAppSelector(selectLineupTransferList);
	const userId = useAppSelector(selectUserId)
	const isAnon = useAppSelector(selectIsAnonymous);
	const dispatch = useAppDispatch();
	const nav = useNavigate();

	const handleTransfer = () => {
		if (lineups.lineups.length + transferList.length < 9) {
			dispatch(postLegacyTitanTVMigrate({ userId, legacyUserId: oldAccount.userId, selectedLineupIdList: transferList }))
		} else {
			alert(`You may only have a total of 8 lineups. You have ${lineups.lineups.length} lineups, you may only transfer ${8 - lineups.lineups.length} lineups`)
		}
	}

	if (oldAccount.errorCode === 1004 || oldAccount.errorCode === -2 || oldAccount.loginNameIsUsed || oldAccount.emailIsUsed) {
		dispatch(setTransferPage(TransferPage.LOGIN));
	}

	if (accountMigrationStatus === DataState.SUCCEEDED) {
		dispatch(fetchUserLineups(userId));
		dispatch(fetchUserSettings(userId));
		dispatch(fetchFavorites(userId));
		dispatch(setAccountMigrationStatus(DataState.IDLE));
		dispatch(setTransferPage(TransferPage.LOGIN))
		nav('/');
	}

	useEffect(() => {
		if (lineupStatus !== DataState.SUCCEEDED) {
			dispatch(fetchUserLineups(userId));
		}
	}, [])

	return (
		<SettingsOptionsContainer>
			{accountMigrationStatus === DataState.LOADING ? <GridLoading /> :
				oldAccountLoadingStatus === DataState.FAILED || lineupStatus === DataState.FAILED ? <GridFailed /> :
					oldAccountLoadingStatus === DataState.LOADING || lineupStatus === DataState.LOADING ? <GridLoading /> :
						oldAccountLoadingStatus === DataState.SUCCEEDED && lineupStatus === DataState.SUCCEEDED ?
							oldAccount.errorCode === 0 ?
								<>
									{/* if the login name from the old account is taken in new Titan */}
									{isAnon ?
										oldAccount.loginNameIsUsed ? <div>Login Name is take, please choose a new Login Name</div> : ''
										: ''
									}
									{/* if the email from the old account is taken in new Titan */}
									{isAnon ?
										oldAccount.emailIsUsed ? <div>Email is take, please provide a new Email</div> : ''
										: ''
									}
									<SettingsHeader>You may only transfer up to {8 - lineups.lineups.length} lineups</SettingsHeader>
									{oldAccount.lineupIds.map((lineup, i) => {
										return (
											<LineupSelectionBox key={lineup.lineupId} lineup={lineup} index={i} />
										)
									})}
									<BlueButton
										onClick={() => handleTransfer()}
									>Transfer Account</BlueButton>
								</>
								:
								<CenterText>
									<DataError>{oldAccount.errorMessage}</DataError>
									<StyledLink to='/account'>Click here to go to the account setup page</StyledLink>
								</CenterText>
							:
							'Missing data'
			}
			{((oldAccountLoadingStatus === DataState.SUCCEEDED && lineupStatus === DataState.SUCCEEDED) && (transferList.length + lineups.lineups.length) > 8) ?
				<DataError>
					You may only have a total of 8 lineups. You have {lineups.lineups.length} lineups so you can only transfer {8 - lineups.lineups.length} lineups
				</DataError>
				: ''
			}
		</SettingsOptionsContainer>
	)
}

// // This is needed because bringing in the transferList caused an infinite loop
// // and I have no idea why
// const TheButton = () => {
// 	const transferList = useAppSelector(selectLineupTransferList);
// 	const oldAccount = useAppSelector(selectOldTitanAccount);
// 	const userId = useAppSelector(selectUserId);
// 	const currentLineupTotal = useAppSelector(selectLineups).lineups.length;
// 	const dispatch = useAppDispatch();

// 	return (
// 		<BlueButton>Transfer Account</BlueButton>
// 	)
// }

export default TransferLineups